import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { History } from "history"

export const lostOrFinishedAdminSession = (
	history: History<unknown> | string[],
	store: {
		setUserHasAdminAccess: any
		setInfoModalConfig: any
	}
) => {
	store.setInfoModalConfig({
		type: "fail",
		titleKey: "admin.end-session",
	})
	sessionStorage.removeItem("access")
	store.setUserHasAdminAccess(false)
	history.push(ROUTES.USER)
}
